import { isLikelyHtml, stripLeadingClosingTags } from "utils/html-detect.util";

/**
 * Rolling-deploy bridge: if the BE returned HTML, pass through;
 * if it returned plaintext (old BE without format support),
 * convert \n → <br /> so line breaks render in HTML contexts.
 *
 * HTML detection requires a leading tag — see isLikelyHtml in html-detect.util.ts. AI output can
 * open with a stray `</p>` (DEV-3624), which would read as plain text and get a `<br />` between
 * every block, so it is stripped first.
 * Remove once all BE instances support format: "html".
 */
export function ensureHtmlLineBreaks(text: string | undefined | null): string {
  if (!text) return "";
  const value = stripLeadingClosingTags(text);
  return isLikelyHtml(value) ? value : value.replaceAll("\n", "<br />");
}
